import arrow from '../../../assets/hammers/intro/arrow.png';
import boxImage from '../../../assets/hammers/intro/box.png';
import hammersImage from '../../../assets/hammers/intro/hammers.png';
import rectImage from '../../../assets/hammers/intro/rect.png';
import titleImage from '../../../assets/hammers/intro/title.png';

export const HAMMERS_INTRO_IMAGES = [titleImage, hammersImage, rectImage, boxImage, arrow];
